import React, { useRef, useState } from 'react';
import cn from 'clsx';
import { DummyPageData } from './dummy-page.data';
import WidgetPage from './pages/widget-page';
import Button from '@components-clean/core/button';
import { DropDownList } from '@components-clean/core/drop-down-list';
import BadgesPage from '@pages-clean/dummy-page/pages/badges-page';
import BulkUpdatePage from '@pages-clean/dummy-page/pages/bulk-update-page';
import ChartsPage from '@pages-clean/dummy-page/pages/charts-page';
import ControlsPage from '@pages-clean/dummy-page/pages/controls-page';
import DataViewConfigPoCPage from '@pages-clean/dummy-page/pages/data-view-config-poc/data-view-config-poc-page';
import DateInputsPage from '@pages-clean/dummy-page/pages/date-inputs-page';
import DialogsPage from '@pages-clean/dummy-page/pages/dialogs-page';
import DragAndDropListsPage from '@pages-clean/dummy-page/pages/drag-and-drop-lists-page';
import ExceptionPage from '@pages-clean/dummy-page/pages/exception-page';
import { FileUploadPage } from '@pages-clean/dummy-page/pages/file-upload-page';
import FiltersPage from '@pages-clean/dummy-page/pages/filters-page';
import FontsPage from '@pages-clean/dummy-page/pages/fonts/fonts-page';
import GridsPage from '@pages-clean/dummy-page/pages/grids-page';
import HighlightGridPocPage from '@pages-clean/dummy-page/pages/highlight-grid-poc';
import HtmlElements from '@pages-clean/dummy-page/pages/html-elements';
import IconsPage from '@pages-clean/dummy-page/pages/icons-page';
import InfiniteScrollGridPage from '@pages-clean/dummy-page/pages/infinite-scroll-grid-page';
import InfoFieldPage from '@pages-clean/dummy-page/pages/info-field-page';
import InputsPage from '@pages-clean/dummy-page/pages/inputs-page';
import LayoutPage from '@pages-clean/dummy-page/pages/layout-page';
import MatadataPage from '@pages-clean/dummy-page/pages/matadata-page';
import PersistentGridPocPage from '@pages-clean/dummy-page/pages/persistent-grid-poc';
import ProgressBarsPage from '@pages-clean/dummy-page/pages/progress-bars-page';
import { RiskCommentsPocPage } from '@pages-clean/dummy-page/pages/risk-comments-poc';
import SplitterPage from '@pages-clean/dummy-page/pages/splitter-page';

const DummyComponentsPage = () => {
    type Screen = (typeof DummyPageData.screens)[keyof typeof DummyPageData.screens];

    const headerRef = useRef<HTMLDivElement>(null);

    const [screen, setScreen] = useState<Screen>(DummyPageData.screens.charts);
    const [isDisabled, setIsDisabled] = useState(false);

    const isDialogsScreen = screen === DummyPageData.screens.dialogs;

    return (
        <div className={cn({ 'k-overflow-x-scroll': isDialogsScreen })} style={{ height: '100%' }}>
            <div ref={headerRef} className="k-d-flex k-pb-4 k-gap-4">
                <DropDownList
                    label="Select a screen:"
                    inline
                    style={{ width: 300 }}
                    data={Object.values(DummyPageData.screens).sort((a, b) => a.localeCompare(b))}
                    value={screen}
                    onChange={(e) => {
                        setScreen(e.value as Screen);
                    }}
                    data-testid="select-screen"
                />
                <Button
                    data-testid="disabled-state-toggle-button"
                    onClick={() => {
                        setIsDisabled(!isDisabled);
                    }}
                >
                    Component State: {isDisabled ? 'DISABLED' : 'ENABLED'}
                </Button>
            </div>

            <div style={{ height: `calc(100% - ${headerRef.current?.clientHeight ?? 68}px)` }}>
                {screen === DummyPageData.screens.badges && <BadgesPage />}
                {screen === DummyPageData.screens.charts && <ChartsPage />}
                {screen === DummyPageData.screens.controls && <ControlsPage isDisabled={isDisabled} />}
                {screen === DummyPageData.screens.dialogs && <DialogsPage />}
                {screen === DummyPageData.screens.filters && <FiltersPage />}
                {screen === DummyPageData.screens.grids && <GridsPage />}
                {screen === DummyPageData.screens.apiGid && <InfiniteScrollGridPage />}
                {screen === DummyPageData.screens.htmlElements && <HtmlElements isDisabled={isDisabled} />}
                {screen === DummyPageData.screens.inputs && <InputsPage isDisabled={isDisabled} />}
                {screen === DummyPageData.screens.layout && <LayoutPage isDisabled={isDisabled} />}
                {screen === DummyPageData.screens.splitter && <SplitterPage />}
                {screen === DummyPageData.screens.widget && <WidgetPage isDisabled={isDisabled} />}
                {screen === DummyPageData.screens.dateInputs && <DateInputsPage />}
                {screen === DummyPageData.screens.metadata && <MatadataPage />}
                {screen === DummyPageData.screens.ddList && <DragAndDropListsPage isDisabled={isDisabled} />}
                {screen === DummyPageData.screens.infoField && <InfoFieldPage />}
                {screen === DummyPageData.screens.icons && <IconsPage />}
                {screen === DummyPageData.screens.DVConfigPoC && <DataViewConfigPoCPage />}
                {screen === DummyPageData.screens.fonts && <FontsPage />}
                {screen === DummyPageData.screens.bulkUpdate && <BulkUpdatePage />}
                {screen === DummyPageData.screens.PersistentGridPoC && <PersistentGridPocPage />}
                {screen === DummyPageData.screens.HighlightRowGridPoC && <HighlightGridPocPage />}
                {screen === DummyPageData.screens.exceptions && <ExceptionPage />}
                {screen === DummyPageData.screens.progressBars && <ProgressBarsPage />}
                {screen === DummyPageData.screens.riskCommentsPoc && <RiskCommentsPocPage />}
                {screen === DummyPageData.screens.fileUpload && <FileUploadPage />}
            </div>
        </div>
    );
};

export default DummyComponentsPage;
